import * as MoEngage from '@porterin/component-library/src/ts-utils/analytics/moengage/MoEngage';
import { MoEngageUserData } from '@porterin/component-library/src/ts-utils/analytics/moengage/MoEngageUserData';
import { CommonTrackingPayloadEvent } from '@porterin/component-library/src/ts-utils/analytics/react-ga/types/CommonTrackingPayload';

interface EventPayload {
  category: string;
  label: string;
  value: string;
  nonInteraction: boolean;
}

export const getTrackEventPayload = (
  payload: CommonTrackingPayloadEvent,
): any => {
  return {
    category: payload.category,
    label: payload.label,
    value: payload.value,
    nonInteraction: payload.nonInteraction,
  };
};

export const moEngageEventsPrefix: string[] = [
  'fe_',
  'Verify OTP',
  'Resend',
  'Sticky',
  'Get Trip',
  'Get Estimate',
  'Login',
  'Sticky Download',
  'Frequency Selection',
];

export const shouldFireMoeEvent = (event_name: string): boolean => {
  return moEngageEventsPrefix.some(event_prefix =>
    event_name.includes(event_prefix),
  );
};

export const setMoengageUser = (moe_user_data: MoEngageUserData): void => {
  MoEngage.addUniqueUserId(moe_user_data.customer_uuid)
    .then(() => {
      MoEngage.addFirstName(moe_user_data.first_name);
      MoEngage.addLastName(moe_user_data.last_name);
      MoEngage.addEmail(moe_user_data.email);
      MoEngage.addMobile(moe_user_data.mobile);
      MoEngage.addClientId(moe_user_data.client_id);
      MoEngage.addSessionId(moe_user_data.session_id);
    })
    .catch(error => {
      console.error('Error setting MoEngage user:', error);
      // TODO: Fire a Sentry event here to capture MoEngage user setting errors.
      // Sentry.captureException(error, {
      //   tags: { module: 'MoEngageHelper', action: 'setUser' }
      // });
    });
};
